exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".navbar-organizers-switch{float:left;margin:14px 5px 5px 14px;width:150px}.navbar-organizers-switch .dropdown-toggle{height:34px;border-radius:5px !important}.navbar-minimalize.minimalize-styl-2.btn.btn-primary{height:34px;font-size:16px}", ""]);

